export const SIZE_ORDER = new Map([
  ['XXXS', 0],
  ['XXS', 1],
  ['XS', 2],
  ['S', 3],
  ['M', 4],
  ['L', 5],
  ['XL', 6],
  ['XXL', 7],
  ['XXXL', 8],
  ['XS/S', 9],
  ['S/M', 10],
  ['M/L', 11],
  ['L/XL', 12],
  ['XL/XXL', 13],
  ['ONE SIZE', 14],
]);

/**
 * Compare two size strings using the SIZE_ORDER map.
 * Falls back to numeric comparison, then localeCompare.
 * @param {string} a - first size
 * @param {string} b - second size
 * @returns {number} comparison result
 */
export function compareSizes(a, b) {
  const ai = SIZE_ORDER.get(a.toUpperCase());
  const bi = SIZE_ORDER.get(b.toUpperCase());
  if (ai != null && bi != null) return ai - bi;
  if (ai != null) return -1;
  if (bi != null) return 1;

  const numA = parseFloat(a);
  const numB = parseFloat(b);
  if (!isNaN(numA) && !isNaN(numB)) return numA - numB;

  return a.localeCompare(b);
}
